import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { useSearchParams } from '../../hooks/useSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SORT_OPTIONS = ['RELEVANCE', 'MOST_INSTALLED', 'NEWEST', 'NAME_AZ', 'NAME_ZA'];
export function SortDropdown() {
  const searchParams = useSearchParams();
  const sortOption = searchParams.get('sort', {
    allowedValues: SORT_OPTIONS
  });
  const handleSortChange = sort => {
    searchParams.set('sort', sort, {
      defaultValue: 'RELEVANCE'
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexShrink: 0,
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(View, {
      flexShrink: 0,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.label"
      })
    }), /*#__PURE__*/_jsx(Dropdown, {
      buttonUse: "transparent",
      buttonText: localizeSortOption(sortOption),
      children: /*#__PURE__*/_jsx(List, {
        children: SORT_OPTIONS.map(option => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            onClick: () => handleSortChange(option),
            children: localizeSortOption(option)
          })
        }, option))
      })
    })]
  });
}
function localizeSortOption(sortOption) {
  switch (sortOption) {
    case 'MOST_INSTALLED':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.mostInstalled"
      });
    case 'NEWEST':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.newest"
      });
    case 'NAME_AZ':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.nameAZ"
      });
    case 'NAME_ZA':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.nameZA"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.searchResults.sort.options.relevance"
      });
  }
}